<template>
  <j-form-container :disabled="disabled">
    <a-form :form="form" slot="detail">
      <a-row>
        <a-col :span="6">
          <a-form-item :label="$t('label.amountOfRecovery')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['recoverPrice', { initialValue: 0, rules: validatorRules.recoverPrice.rules }]" :placeholder="$t('label.pleaseEnterTheAmountRecovered')"
                            @change="recoverPriceChange"
                            disabled
                            style="width: 84%"/>
            {{ $t('label.yuan') }}
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :label="$t('label.costAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['costPrice', { initialValue: 0, rules: validatorRules.costPrice.rules }]" :placeholder="$t('label.pleaseEnterTheCostAmount')"
                            @change="costPriceChange"
                            disabled
                            style="width: 84%"/>
            {{ $t('label.yuan') }}
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :label="$t('label.subsidyAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['subsidyPrice', { initialValue: 0, rules: validatorRules.subsidyPrice.rules }]" :placeholder="$t('label.pleaseEnterTheAmountOfSubsidy')"
                            @change="subsidyPriceChange"
                            disabled
                            style="width: 84%"/>
            {{ $t('label.yuan') }}
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :label="$t('label.otherSubsidies')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['otherSubsidyPrice', validatorRules.otherSubsidyPrice]" :placeholder="$t('label.pleaseEnterOtherSubsidies')"
                            @change="otherSubsidyPriceChange"
                            style="width: 84%"/>
            {{ $t('label.yuan') }}
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="6">
          <a-form-item :label="$t('label.costAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['outlayPrice', { initialValue: 0, rules: validatorRules.outlayPrice.rules }]" :placeholder="$t('label.pleaseEnterTheAmountOfExpenses')"
                            @change="outlayPriceChange"
                            disabled
                            style="width: 84%"/>
            {{ $t('label.yuan') }}
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :label="$t('label.penaltyAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['punishPrice', { initialValue: 0, rules: validatorRules.punishPrice.rules }]" :placeholder="$t('label.pleaseEnterTheAmountOfPenalty')"
                            @change="punishPriceChange"
                            disabled
                            style="width: 84%"/>
            {{ $t('label.yuan') }}
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :label="$t('label.otherPenalties')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['otherPunishPrice', validatorRules.otherPunishPrice]" :placeholder="$t('label.pleaseEnterOtherPenalties')"
                            @change="otherPunishPriceChange"
                            style="width: 84%"/>
            {{ $t('label.yuan') }}
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :label="$t('label.basicSurrogateFee')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['baseFosterPrice', validatorRules.baseFosterPrice]" style="width: 84%" disabled/>
            {{ $t('label.yuan') }}
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="6">
          <a-form-item :label="$t('label.marginBalance')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['marginBalance', validatorRules.marginBalance]" style="width: 84%" disabled/>
            {{ $t('label.yuan') }}
          </a-form-item>
        </a-col>
        <a-col :span="6" :offset="12">
          <a-form-item :label="$t('label.amountDue')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['payPrice', validatorRules.payPrice]" style="width: 84%" disabled/>
            {{ $t('label.yuan') }}
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="6">
          <a-form-item :label="$t('label.marginWithholding')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['marginDeduct', validatorRules.marginDeduct]" style="width: 84%" @change="marginDeductChange"/>
            {{ $t('label.yuan') }}
          </a-form-item>
        </a-col>
        <a-col :span="6" :offset="12">
          <a-form-item :label="$t('label.actualAmountPaid')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['actualPayPrice', validatorRules.actualPayPrice]" style="width: 84%" disabled/>
            {{ $t('label.yuan') }}
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </j-form-container>
</template>
<script>
    import pick from 'lodash.pick'
    import JFormContainer from '@/components/jeecg/JFormContainer'
    import { getAction } from '@/api/manage'

    export default {
        name: 'SettleSettlementListFrom',
        components: {
            JFormContainer,
        },
        props: {
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data() {
            return {
                form: this.$form.createForm(this),
                model: {},
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 10 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 14 },
                },
                labelCol2: {
                    xs: { span: 24 },
                    sm: { span: 3 },
                },
                wrapperCol2: {
                    xs: { span: 24 },
                    sm: { span: 20 },
                },
                validatorRules: {
                    recoverPrice: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheAmountRecovered') },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    costPrice: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheCostAmount')},
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    subsidyPrice: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheAmountOfSubsidy')},
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    otherSubsidyPrice: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterOtherSubsidies') },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    outlayPrice: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheAmountOfExpenses') },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    punishPrice: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheAmountOfPenalty') },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    otherPunishPrice: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterOtherPenalties') },
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    baseFosterPrice: {
                        rules: [
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
                        ]
                    },
                    marginBalance: {
                        rules: [
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
                        ]
                    },
                    payPrice: {
                        rules: [
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
                        ]
                    },
                    marginDeduct: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheAmountOfDepositWithholding')},
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber') },
                        ]
                    },
                    actualPayPrice: {
                        rules: [
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
                        ]
                    },
                },
                confirmLoading: false,
                unitPrice10: true,
                unitPrice20: false,
                schemeUnitPriceFormula: null,
                schemeUnitPriceName: null,
                schemeUnitPriceDes: null,
                url: {
                    querySchemeByCode: '/efs/scheme/unitprice/queryByCode',
                },
                recoverPriceTmp: 0,
                costPriceTmp: 0,
                subsidyPriceTmp: 0,
                otherSubsidyPriceTmp: 0,
                outlayPriceTmp: 0,
                punishPriceTmp: 0,
                otherPunishPriceTmp: 0,
                marginDeductTmp: 0,
                cooperModeTmp: null,
                // costPriceSymbol: "sub"
            }
        },
        created() {
            // 回收金额
            this.$bus.$on("totalRecoveryAmount", res => {
                this.model.recoverPrice = res
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(this.model, 'recoverPrice'))
                })
                this.recoverPriceChange(res)
            });
            // 成本金额
            this.$bus.$on("expendPriceEmit", res => {
                this.model.costPrice = res
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(this.model, 'costPrice'))
                })
                this.costPriceChange(res)
            });
            // 补贴金额
            this.$bus.$on("subsidyTableEmit", res => {
                this.model.subsidyPrice = res
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(this.model, 'subsidyPrice'))
                })
                this.subsidyPriceChange(res)
            });
            // 费用金额
            this.$bus.$on("costTableEmit", res => {
                this.model.outlayPrice = res
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(this.model, 'outlayPrice'))
                })
                this.outlayPriceChange(res)
            });
            // 惩罚金额
            this.$bus.$on("punishTableEmit", res => {
                this.model.punishPrice = res
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(this.model, 'punishPrice'))
                })
                this.punishPriceChange(res);
            });
            // 合作模式
            this.$bus.$on("cooperModeEmit", res => {
                this.cooperModeTmp = res;
                this.caleActualPayPrice()
            });
        },
        methods: {
            initFormData(url, id) {
                this.clearFormData()
                if (!id) {
                    this.edit({})
                } else {
                    getAction(url, { id: id }).then(res => {
                        if (res.success) {
                            let records = res.result
                            this.edit(records)
                        }
                    })
                }
            },
            formDataByBreedCode(url, code) {
                getAction(url, { breedCode: code }).then(res => {
                    if (res.success) {
                        if(res.result.balance){
                            this.model.marginBalance = res.result.balance;
                        }else {
                            this.model.marginBalance = 0;
                        }
                        this.$nextTick(() => {
                            this.form.setFieldsValue(pick(this.model, 'marginBalance'))
                        })
                        this.calePayPrice()
                        this.caleActualPayPrice()
                    }
                })
            },
            edit(record) {
                this.model = Object.assign({}, record)
                let fieldval = pick(this.model, 'recoverPrice', 'costPrice', 'subsidyPrice', 'otherSubsidyPrice', 'otherPunishPrice', 'punishPrice', 'outlayPrice', 'baseFosterPrice', 'marginBalance', 'payPrice', 'marginDeduct', 'actualPayPrice')
                this.$nextTick(() => {
                    this.form.setFieldsValue(fieldval)
                })
                if(this.model.id){
                    this.recoverPriceChange(this.model.recoverPrice);
                    this.costPriceChange(this.model.costPrice);
                    this.subsidyPriceChange(this.model.subsidyPrice);
                    this.otherSubsidyPriceChange(this.model.otherSubsidyPrice);
                    this.outlayPriceChange(this.model.outlayPrice);
                    this.punishPriceChange(this.model.punishPrice);
                    this.otherPunishPriceChange(this.model.otherPunishPrice);
                }
            },
            getFormData() {
                let formdata_arr = []
                this.form.validateFields((err, values) => {
                    if (!err) {
                        let formdata = Object.assign(this.model, values)
                        let isNullObj = true
                        Object.keys(formdata).forEach(key => {
                            if (formdata[key]) {
                                isNullObj = false
                            }
                        })
                        if (!isNullObj) {
                            formdata_arr.push(formdata)
                        }
                    } else {
                        this.$emit('validateError', '结算表单校验未通过')
                        return;
                    }
                })
                return formdata_arr
            },
            clearFormData() {
                this.form.resetFields()
                this.model = {}
            },
            recoverPriceChange(event) {
                this.recoverPriceTmp = event
                this.caleBaseFosterPrice()
                this.calePayPrice()
                this.caleActualPayPrice()
            },
            costPriceChange(event) {
                this.costPriceTmp = event
                this.caleBaseFosterPrice()
                this.calePayPrice()
                this.caleActualPayPrice()
            },
            subsidyPriceChange(event) {
                this.subsidyPriceTmp = event;
                this.caleBaseFosterPrice()
                this.calePayPrice()
                this.caleActualPayPrice()
            },
            otherSubsidyPriceChange(event) {
                this.otherSubsidyPriceTmp = event;
                this.caleBaseFosterPrice()
                this.calePayPrice()
                this.caleActualPayPrice()
            },
            outlayPriceChange(event) {
                this.outlayPriceTmp = event
                this.caleBaseFosterPrice()
                this.calePayPrice()
                this.caleActualPayPrice()
            },
            punishPriceChange(event) {
                this.punishPriceTmp = event
                this.caleBaseFosterPrice()
                this.calePayPrice()
                this.caleActualPayPrice()
            },
            otherPunishPriceChange(event) {
                this.otherPunishPriceTmp = event
                this.caleBaseFosterPrice()
                this.calePayPrice()
                this.caleActualPayPrice()
            },
            marginDeductChange(event){
                this.marginDeductTmp = event
                this.caleActualPayPrice()
            },
            // 计算基本代养费
            caleBaseFosterPrice() {
                // 基本代养费=回收金额-成本金额+补贴金额-费用金额-惩罚金额
                this.model.baseFosterPrice = (Number(this.recoverPriceTmp) - Number(this.costPriceTmp) + Number(this.subsidyPriceTmp) + Number(this.otherSubsidyPriceTmp) - Number(this.outlayPriceTmp) - Number(this.punishPriceTmp) - Number(this.otherPunishPriceTmp)).toFixed(3);
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(this.model, 'baseFosterPrice'))
                })
            },
            // 计算应付金额
            calePayPrice(){
                this.model.payPrice = (Number(this.recoverPriceTmp) - Number(this.costPriceTmp) + Number(this.subsidyPriceTmp) + Number(this.otherSubsidyPriceTmp) - Number(this.outlayPriceTmp) - Number(this.punishPriceTmp) - Number(this.otherPunishPriceTmp) + Number(this.model.marginBalance)).toFixed(3);
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(this.model, 'payPrice'))
                })
            },
            // 计算实付金额
            caleActualPayPrice(){
                // 实付金额=基本代养费+余额-扣缴
                if(this.cooperModeTmp == '30'){
                    this.model.actualPayPrice = (Number(this.recoverPriceTmp) + Number(this.subsidyPriceTmp) + Number(this.otherSubsidyPriceTmp) - Number(this.outlayPriceTmp) - Number(this.punishPriceTmp) - Number(this.otherPunishPriceTmp) + Number(this.model.marginBalance) - Number(this.marginDeductTmp)).toFixed(3);
                }else {
                    this.model.actualPayPrice = (Number(this.recoverPriceTmp) - Number(this.costPriceTmp) + Number(this.subsidyPriceTmp) + Number(this.otherSubsidyPriceTmp) - Number(this.outlayPriceTmp) - Number(this.punishPriceTmp) - Number(this.otherPunishPriceTmp) + Number(this.model.marginBalance) - Number(this.marginDeductTmp)).toFixed(3);
                }
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(this.model, 'actualPayPrice'))
                })
            }
        }
    }
</script>
